import { Injectable } from '@angular/core';
import { User } from 'app/models';
import { Observable } from 'rxjs';
import { UserApi } from '../user.api';

@Injectable({
  providedIn: 'root',
  useClass: UserApi, // Default class
})
export abstract class IUserApi {
  abstract getUser(userId?: number): Observable<User>;
}
